var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 19.5C9.10005 19.5 10.0001 18.6 10.0001 17.5H6.00005C6.00005 18.6 6.89005 19.5 8.00005 19.5ZM14.0001 13.5V8.5C14.0001 5.43 12.3601 2.86 9.50005 2.18V1.5C9.50005 0.67 8.83005 0 8.00005 0C7.17005 0 6.50005 0.67 6.50005 1.5V2.18C3.63005 2.86 2.00005 5.42 2.00005 8.5V13.5L0.710051 14.79C0.0800515 15.42 0.520051 16.5 1.41005 16.5H14.5801C15.4701 16.5 15.9201 15.42 15.2901 14.79L14.0001 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.1efd135754074379a679c8def0f11887.svg";
export { ForwardRef as ReactComponent };